import config from '../config'

export const legacyRedirect = (page: string) =>
  (window.location.href = `${config.legacyQuoteOrigin}/${page}?referrer=checkout`)
